import { useState } from 'react';
import { DataTable, Page, Card } from '@shopify/polaris';
import SettingsAddEditModal, { getSettingsEditLink } from '../../settingsAddEditModal';
import { openAddModal } from '../../../../shared/components/settingsFunctions.js';
import Toasts from '../../../../shared/components/toasts/toasts.jsx';
import { useLookupStore } from '../../../../context/useStore.js';
import { useToggle } from '../../../../shared/useToogle.js';

export default function SettingsContactTitlesPage() {
  const [contacttitels, setContacttitels] = useLookupStore((state) => [state.contacttitels, state.setContacttitels]);
  const [modalOpen, setModalOpen] = useToggle(false);
  const [entryId, setEntryId] = useState('');
  const [isAdd, setIsAdd] = useState(true);
  const [entry, setEntry] = useState({
    AanspreektitelNL: { type: 'text', label: 'NL', max: '20', value: '' },
    AanspreektitelFR: { type: 'text', label: 'FR', max: '20', value: '' },
    AanspreektitelDE: { type: 'text', label: 'DE', max: '20', value: '' },
    AanspreektitelUK: { type: 'text', label: 'UK', max: '20', value: '' }
  });
  const [toast, setToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const url = '/api/contacttitels';
  const title = 'Contact titles';

  const rows = contacttitels.map((item) => {
    return [
      item.AanspreektitelNL,
      item.AanspreektitelFR,
      item.AanspreektitelDE,
      item.AanspreektitelUK,
      getSettingsEditLink(setModalOpen, entry, setEntry, setIsAdd, setEntryId, item, item.AanspreektitelID)
    ];
  });

  return (
    <Page
      title={title}
      backAction={{ content: 'Settings', url: '/settings' }}
      primaryAction={{ content: 'Add contact title', onAction: async () => openAddModal(setModalOpen, entry, setEntry, setIsAdd, setEntryId) }}
    >
      <SettingsAddEditModal
        modalTitle={title}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        isAdd={isAdd}
        entry={entry}
        setEntry={setEntry}
        entryId={entryId}
        url={url}
        setToast={setToast}
        setErrorToast={setErrorToast}
        setItems={setContacttitels}
      />
      <Toasts toast={toast} setToast={setToast} errorToast={errorToast} setErrorToast={setErrorToast} />
      <Card>
        <DataTable
          stickyHeader
          increasedTableDensity
          verticalAlign="middle"
          columnContentTypes={['text', 'text', 'text', 'text', 'numeric']}
          headings={[<b>NL</b>, <b>FR</b>, <b>DE</b>, <b>EN</b>, <b>Edit</b>]}
          rows={rows}
        />
      </Card>
    </Page>
  );
}
